import PropTypes from 'prop-types';
import cn from '../../../../utils/cn';

const StyleButton = ({ style, active, label, onToggle }) => {
  const handleToggle = (e) => {
    e.preventDefault();
    onToggle(style);
  }

  const btnClasses = () => cn({
    'mt-1 text-dark-border-grey cursor-pointer mr-2 py-1 px-2 inline-block': true,
    'text-action-blue': active,
    'font-bold': style === 'BOLD',
    'italic': style === 'ITALIC',
    'underline': style === 'UNDERLINE',
  });

  return (
    <span
      className={btnClasses()}
      onMouseDown={handleToggle}
      role="button"
      tabIndex={0}
    >
      {label}
    </span>
  );
};

StyleButton.propTypes = {
  active: PropTypes.bool.isRequired,
  label: PropTypes.node.isRequired,
  onToggle: PropTypes.func.isRequired,
  style: PropTypes.string.isRequired,
};

export default StyleButton;
